exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slider{top:0;left:0;z-index:0;perspective:1000px}.slide-container,.slider{position:absolute;height:100%;width:100%}.slide-container{transform-style:preserve-3d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0d1ca544!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/Slider/Slider.vue
// module id = 110
// module chunks = 0